import React from 'react'
import View from '@databyss-org/ui/primitives/View/View'
import Separator from '@databyss-org/ui/primitives/List/Separator'

export const SectionSeparator = () => (
  <View>
    <Separator spacing="none" color="white" />
  </View>
)
